export const TOKEN = 'gli-token'
export const REFRESH_TOKEN = 'gli-refresh-token'
export const USER_INFO = 'user-info'
export const COURSE_TYPE_PRIVATE = 0
export const COURSE_TYPE_PUBLIC = 1
export const ErrCode = {
  OK: 200,
  TokenTimeout: 12001,
  TokenError: 12002,
  LoginByAnotherOne: 12003,
}

export const ActionTypes = {
  SAVE_EMPLOYEE: 'SAVE_EMPLOYEE',
  FETCH_MEMBER_BY_ID_COMPLETED: 'FETCH_MEMBER_BY_ID_COMPLETED',
  UPDATE_MEMBER_FIELD: 'UPDATE_MEMBER_FIELD',
  SAVE_MEMBER: 'SAVE_MEMBER',

  // 编辑客户公司信息弹窗
  ShowEditCompanyModal: 'ShowEditCompanyModal',
  HideEditCompanyModal: 'HideEditCompanyModal',
  SetEditCompany: 'SetEditCompany',
  RefreshCompanyList: 'RefreshCompanyList',

  //编辑用户信息
  SAVE_USER: 'SAVE_USER',

  // 更新年级大纲
  UpdateOrgTypes: 'UpdateOrgTypes',
}

export const MEvents = {
  TokenError: 'TokenError',
  LoginByAnotherOne: 'LoginByAnotherOne',
}
export const CourseAnnexTypes = {
  Courseware: 1,
  LessonPlan: 2,
  Video: 3,
}
export const RememberPasswordKey = 'PleaseDoWhatYouWannaDo'
